import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import img from "../../images/ayushi-villa.png";
import { Spinner } from "react-bootstrap";
import video from "../../video/Ayushi Villa.mp4";
import { FaWhatsapp, FaUser , FaHeadset} from "react-icons/fa";
import GoogleMapCom from "../../pages/GoogleMapCom";
import { Helmet } from "react-helmet-async";

function Ayushi_Villa() {
  const images = [{ src: "", title: "Entry Gate" }];
  const [loading, setLoading] = useState(true);

  const handleLoadedData = () => {
    setLoading(false);
  };

  return (
    <Wrapper>
      <Helmet>
        <title>Ayushi Villa | Independent Villas in Jabalpur</title>
        <meta
          name="description"
          content="Ayushi Villa offers completed independent duplex homes in Jabalpur with spacious layouts and quality finishes. Get in touch with us to explore resale options today."
        />
        <meta
          name="keywords"
          content="ayushi villa jabalpur, independent villas jabalpur, duplex homes jabalpur"
        />
        <link
          rel="canonical"
          href="https://ayushiconstruction.com/ayushi-villa"
        />
      </Helmet>

      <div className="container">
        <div className="row align-items-center mt-5 g-4 mb-5">
          <div className="col-lg-6 mt-3">
            <div
              className="about-content s-about-content pl-30"
              data-aos="fade-right"
            >
              <div className="about-title second-atitle">
                <h2>Welcome To Ayushi Villa</h2>
              </div>
              <p>
                A prestigious residential project located in the prime area of
                Ganganagar Garha. Spanning across 1.52 acres, this fully
                completed project features 39 exquisitely designed 4 BHK Triplex
                Villas, all of which have been successfully sold, reflecting its
                unmatched demand and exclusivity. Each villa is thoughtfully
                crafted to offer a premium living experience, with modern
                architecture, spacious interiors, and top-notch amenities.
                Designed for comfort and elegance, these triplex villas provide
                ample natural light, open spaces, and luxurious finishes.
                Strategically located, Ayushi Villa ensures seamless
                connectivity to major city landmarks, schools, hospitals, and
                shopping centers, offering convenience and a high standard of
                living.
              </p>
              <div className="d-flex flex-wrap gap-4">
                <div className="">
                  <li>
                    <strong>Site Address : - </strong>Ganganagar Garha.
                  </li>
                  <li>
                    <strong>No. of Units : - </strong>39
                  </li>
                  <li>
                    <strong>Status : - </strong>Project completed
                  </li>
                </div>
                <div className="">
                  <li>
                    <strong>No. of Sale Unit : - </strong>39
                  </li>
                  <li>
                    <strong>Project Type : - </strong>4 BHK Triplex Villas
                  </li>
                  <li>
                    <strong>Land Area : - </strong>1.52 acre
                  </li>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="s-about-img p-relative" data-aos="fade-left">
              <img src={img} alt="img" />
            </div>
          </div>

          <div className="col-lg-12">
            <h2>AMENITIES</h2>
          </div>
          <div className="col-lg-3">
            <h6>Grand Gentry Enterance</h6>
          </div>
          <div className="col-lg-3">
            <h6>CCTV Covered Campus</h6>
          </div>
          <div className="col-lg-3">
            <h6>Commercial Units/Shops</h6>
          </div>
          <div className="col-lg-3">
            <h6>Water Supply</h6>
          </div>
          <div className="col-lg-3">
            <h6>Kids Play Area</h6>
          </div>

          <div className="col-lg-3">
            <h6>Soalr Lighting</h6>
          </div>

          <div className="col-lg-3">
            <h6>24 Hours Water Supply</h6>
          </div>
          <div className="col-lg-3">
            <h6>Jogging Track- Footpath</h6>
          </div>
          <div className="col-lg-3">
            <h6>Beautiful garden</h6>
          </div>

          <div className="col-lg-12 mt-4">
            <h2>SPECIFICATIONS</h2>
          </div>
          <div className="col-lg-3">
            <h6>Construction with fly ash bricks and M send</h6>
          </div>
          <div className="col-lg-3">
            <h6>ISI TMT iron Saria</h6>
          </div>
          <div className="col-lg-3">
            <h6>Flush Door</h6>
          </div>
          <div className="col-lg-3">
            <h6>Personal water tank 1000 ltr capacity.</h6>
          </div>

          <div className="col-lg-3">
            <h6>Vitrified tiles</h6>
          </div>
          <div className="col-lg-3">
            <h6>
              Window ms steel grill with three track UPVC section tuffan glass.
            </h6>
          </div>
          <div className="col-lg-3">
            <h6>Wooden panelling or granite panelling on doors.</h6>
          </div>
          <div className="col-lg-3">
            <h6>
              Double coat putty finish one coat primer and double coat paint.
            </h6>
          </div>
          <div className="col-lg-3">
            <h6>Wiring and modular switch Anchor/CPL.</h6>
          </div>
          <div className="col-lg-3">
            <h6>Modular kitchen with chimney</h6>
          </div>

          <div className="col-lg-3">
            <h6>Green Marble Kitchen Top</h6>
          </div>
          <div className="col-lg-3">
            <h6>Green Marble on Stairs</h6>
          </div>
          <div className="col-lg-3">
            <h6>Quba/Godrej locks and hendle.</h6>
          </div>
          <div className="col-lg-3">
            <h6>SS Grill on balcony</h6>
          </div>
          <div className="col-lg-3 ">
            <h6>MS and SS Grill on balcony</h6>
          </div>
          <div className="col-lg-3 ">
            <h6>Anit skid tiles on washroom 12"X18"</h6>
          </div>
          <div className="col-lg-3 ">
            <h6>Parking tiles 12mm 16"X16"</h6>
          </div>
          <div className="col-lg-3 ">
            <h6>MS Gate</h6>
          </div>
          <div className="col-lg-3 ">
            <h6>Tukdi Roof protection for water leakage</h6>
          </div>
          <div className="position-relative" id="cont">
            <h2 className="text-center">Video</h2>
            <div
              className="underline mx-auto"
              style={{
                height: 3,
                width: "3rem",
                backgroundColor: "#34495E",
                marginTop: 20,
                marginBottom: 20,
              }}
            ></div>
            <div className="mt-4">
              {loading && (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "black",
                    zIndex: 10,
                  }}
                >
                  <Spinner animation="border" variant="light" />{" "}
                  {/* Change this to your preferred loader */}
                </div>
              )}
              <div className="text-center">
                <video
                  src={video}
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="metadata"
                  onLoadedData={handleLoadedData}
                  style={{
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
          <GoogleMapCom locationUrl="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3668.2875157258477!2d79.88418817603912!3d23.159704211195507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3981b10015d32a01%3A0xd6a44bad73607f0!2sAyushi%20Villa!5e0!3m2!1sen!2sin!4v1742814300670!5m2!1sen!2sin" />
          <div className="container text-center mt-5">
            <div className="h4" style={{ color: "#f26a20" }}>
              Let us connect{" "}
            </div>
            <div
              className="underline mx-auto"
              style={{
                height: 3,
                width: "3rem",
                backgroundColor: "#34495E",
                marginTop: 20,
                marginBottom: 20,
              }}
            ></div>
            <div className="d-flex justify-content-center align-items-center gap-5 mt-4">
              <div className="text-center">
                <a
                  href="https://wa.me/917880008031?text=Hi!%20I%20came%20across%20the%20Ayushi%20Villa%20project%20on%20your%20website,%20and%20I%E2%80%99m%20interested%20in%20exploring%20more%20about%20it.%20Could%20we%20discuss%20the%20details?"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-dark"
                >
                  <div style={{
                    width: '60px', 
                    height: '60px', 
                    backgroundColor: 'white', 
                    borderRadius: '50%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    margin: '0 auto',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                  }}>
                    <FaWhatsapp size="35px" color="#25D366" />
                  </div>
                  <p className="mt-2 mb-0 fw-bold" style={{ fontSize: '14px' }}>Chat on WhatsApp</p>
                </a>
              </div>
              
              <div className="text-center">
                <Link to="/contact" className="text-decoration-none text-dark" onClick={() => window.scrollTo(0, 0)}>
                  <div style={{
                    width: '60px', 
                    height: '60px', 
                    backgroundColor: 'white', 
                    borderRadius: '50%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    margin: '0 auto',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                  }}>
                    <FaHeadset size="30px" color="#f26a20" />
                  </div>
                  <p className="mt-2 mb-0 fw-bold" style={{ fontSize: '14px' }}>Contact Us</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default Ayushi_Villa;
const Wrapper = styled.div`
  img {
    width: 100%;
  }

  .imgset {
    height: 25rem;
  }

  h2 {
    color: #f26a20;
  }
  .card-title {
    color: #f26a20;
  }
  .container {
    margin-top: 6rem;
  }
  video {
    width: 25%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`;
